import React from 'react'
import { BreachWallStyle } from '../../user-registration/breach/helpers/BreachWallTypes'
import {
    StyledIconPremium,
    StyledMessageBannerWrapper,
    StyledMessageCTA,
    StyleMessageCTAIconBannerGroup,
    StyledMessageBannerNewBreach,
} from './MessageBannerSmall.styled'

export interface MessageBannerSmallProps {
    icon?: 'comment' | 'subscriber'
    id?: string
    onEvent: (event: any) => void
    isLightText?: boolean
    breachStyle?: BreachWallStyle
}

export const MessageBannerSmall: React.FC<MessageBannerSmallProps> = ({
    icon,
    id,
    children,
    isLightText,
    breachStyle,
}) => {
    return (
        <StyledMessageBannerNewBreach id={id}>
            <StyledMessageBannerWrapper>
                <StyleMessageCTAIconBannerGroup breachStyle={breachStyle}>
                    {icon === 'subscriber' && (
                        <StyledIconPremium breachStyle={breachStyle} />
                    )}
                    <StyledMessageCTA
                        isLightText={isLightText}
                        breachStyle={breachStyle}
                    >
                        {children}
                    </StyledMessageCTA>
                </StyleMessageCTAIconBannerGroup>
            </StyledMessageBannerWrapper>
        </StyledMessageBannerNewBreach>
    )
}

MessageBannerSmall.displayName = 'MessageBannerSmall'
